import { clients } from 'modules/settings/submodules/clients/reducer';
import { combineReducers } from 'redux';
import {
    ClientSettingsAction,
    setClientStatuses,
} from 'modules/settings/submodules/clients/store/actions';
import { IClientStatuses } from 'modules/settings/submodules/clients/store/models';
import { isLoadingReducer } from 'store/reducerUtils';

export const initialState = {
    currentClientId: '',
    clientStatuses: [],
    clientManagers: [],
    clientPayrollRep: [],
};

function clientStatuses(
    state: IClientStatuses[] = initialState.clientStatuses, action: ClientSettingsAction,
): IClientStatuses[] {
    switch (action.type) {
        case setClientStatuses.successType:
            return action.payload;
        default:
            return state;
    }
}

const isClientStatusesLoading = isLoadingReducer(setClientStatuses);

export const clientsSettings = combineReducers({
    clientStatuses,
    isClientStatusesLoading,
    clients,
});
